import { memo } from 'react';
import { Hint, SVG } from 'app/pages/request-single-page/components-v4';
import { Icons } from 'app/pages/request-single-page/components-v4/icons';
import { useV4Theme } from 'app/pages/request-single-page/components-v4/theme';

export const AutomaticIcon = memo(() => {
  const theme = useV4Theme();

  return (
    <Hint text="Автоматизированный счётчик — вводить показания вручную не требуется">
      <div>
        <SVG
          src={Icons.Wifi}
          props={{
            color: theme.colors.gray[400],
            size: '24px',
          }}
        />
      </div>
    </Hint>
  );
});
